import { z } from "zod";

export const getEditFeeFormModelSchema = () =>
	z.object({
		serviceFeePercentage: z
			.number()
			.refine((val) => Number.isFinite(val))
			.nullable()
			.optional(),
		serviceFeeDiscountPercentage: z
			.number()
			.refine((val) => Number.isFinite(val))
			.nullable()
			.optional(),
		customerVATPercentage: z
			.number()
			.refine((val) => Number.isFinite(val))
			.nullable()
			.optional(),
		depositPercentage: z
			.number()
			.refine((val) => Number.isFinite(val))
			.nullable()
			.optional(),
	});

export type EditFeeFormModel = z.infer<
	ReturnType<typeof getEditFeeFormModelSchema>
>;
